var colors = require('../Colors.js');

module.exports = {
  label: 'Material',
  children: {
    ZI: {
      label: 'Zirkon',
      children: {
        Gerüst: {
          label: 'Gerüst',
          itemnum: '3.1.1',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO', 'V', 'I', 'T1'],
        },
        Geschiebe: {
          label: 'Geschiebe',
          itemnum: '3.1.2',
          indications: ['KO', 'KVO', 'KMO']
        },
        Teilungsgeschiebe: {
          label: 'Teilungsgeschiebe',
          itemnum: '3.1.3',
          indications: ['KO', 'KVO', 'KMO', 'KO2', 'KVO2', 'KMO2']
        },
      }
    },
    CoCr_milled: {
      label: 'CoCr gefräst',
      children: {
        Gerüst: {
          label: 'Gerüst',
          itemnum: '3.2.1',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KH', 'KVO', 'KMH', 'KMO']
        },
        Abutment: {
          label: 'Abutment',
          itemnum: '3.3.2',
          indications: ['ST', 'STM', 'STV', 'K', 'KM', 'KV', 'B', 'BV', 'BM'],
        },
        Tertiärkonstruktion: {
          label: 'Tertiärkonstruktion',
          itemnum: '3.2.3',
          indications: ['TER'],
        },
        "Steg auf Klebebasen": {
          label: 'Steg auf Klebebasen',
          indications: ['I', 'EO', 'O'],
          children: {
            x2: {
              label: '2 Implantate',
              itemnum: '3.2.4',
            },
            x3: {
              label: '3 Implantate',
              itemnum: '3.2.5',
            },
            x4: {
              label: '4 Implantate',
              itemnum: '3.2.6',
            },
            x5: {
              label: '5 Implantate',
              itemnum: '3.2.7',
            },
            x6: {
              label: '6 Implantate',
              itemnum: '3.2.8',
            },
            x7: {
              label: '7 Implantate',
              itemnum: '3.2.9',
            },
            x8: {
              label: '8 Implantate',
              itemnum: '3.2.10',
            },
          }
        },
        Stegüberwurf: {
          label: 'Stegüberwurf mit Halteelementen',
          itemnum: '3.2.11',
          indications: ['STE'],
        },
        Modellguss: {
          label: 'Modellguss',
          itemnum: '3.2.12',
          indications: ['MOG'],
        },
        Implantatbrücke: {
          label: 'Implantatbrücke',
          indications: ['I', 'O', 'B', 'BV', 'BM'],
          children: {
            x2: {
              label: '2 Implantate',
              itemnum: '3.2.13',
            },
            x3: {
              label: '3 Implantate',
              itemnum: '3.2.14',
            },
            x4: {
              label: '4 Implantate',
              itemnum: '3.2.15',
            },
            x5: {
              label: '5 Implantate',
              itemnum: '3.2.16',
            },
            x6: {
              label: '6 Implantate',
              itemnum: '3.2.17',
            },
          }
        },
        "Steg mit Anschlüssen": {
          label: 'Steg mit Anschlüssen',
          indications: ['I', 'EO', 'O'],
          children: {
            x2: {
              label: 'Steg mit 2 Anschlüssen',
              itemnum: '3.2.18',
            },
            x3: {
              label: 'Steg mit 3 Anschlüssen',
              itemnum: '3.2.19',
            },
            x4: {
              label: 'Steg mit 4 Anschlüssen',
              itemnum: '3.2.20',
            },
            x5: {
              label: 'Steg mit 5 Anschlüssen',
              itemnum: '3.2.21',
            },
            x6: {
              label: 'Steg mit 6 Anschlüssen',
              itemnum: '3.2.22',
            },
            x7: {
              label: 'Steg mit 7 Anschlüssen',
              itemnum: '3.2.23',
            },
            x8: {
              label: 'Steg mit 8 Anschlüssen',
              itemnum: '3.2.24',
            },
          }
        },
      }
    },
    LaserMelting: {
      label: 'CoCr Laser Melting',
      properties: {
        mat: {
          type: 'html',
          value: 'Material: remanium star® powder',
        },
      },
      children: {
        "Gerüst zum Verblenden": {
          label: 'Gerüst zum Verblenden',
          itemnum: '3.3.1',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KH', 'KVO', 'KMH', 'KMO'],
        },
        "Gerüst teil- oder vollanatomisch": {
          label: 'Gerüst teil- oder vollanatomisch',
          itemnum: '3.3.2',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KH', 'KVO', 'KMH', 'KMO'],
        },
        Primärteleskope: {
          label: 'Primärteleskope',
          itemnum: '3.3.3',
          indications: ['T1']
        },
        /*Sekundärteleskope: {
          label: 'Sekundärteleskope',
          itemnum: '3.3.4',
          indications: ['TM', 'T2M', 'T2V', 'T', 'T2', 'TV', 'ST', 'STV', 'STM'],
        },
        "Retentionen je  Quadrant": {
          label: 'CoCr Retentionen je  Quadrant',
          itemnum: '3.3.5',
          indications: ['R']
        },*/
        "Löt-/Klebeverbinder je Sekundärteleskop": {
          label: 'Löt-/Klebeverbinder je Sekundärteleskop',
          itemnum: '3.3.6',
          indications: ['R']
        },
        Geschiebe: {
          label: 'Geschiebe',
          itemnum: '3.3.7',
          indications: ['O']
        },
        Teilungsgeschiebe: {
          label: 'Teilungsgeschiebe',
          itemnum: '3.3.8',
          indications: ['O']
        },
        Tertiärkonstruktion: {
          label: 'Tertiärkonstruktion',
          itemnum: '3.3.9',
          indications: ['TER']
        },
        Modellguss: {
          label: 'Modellguss',
          itemnum: '3.3.10',
          indications: ['MOG']
        },
        KlammerModellguss: {
          label: 'KlammerModellguss',
          itemnum: '3.3.11',
          indications: ['MOG']
        },
        Stiftaufbau: {
          label: 'Stiftaufbau',
          itemnum: '3.3.12',
          indications: ['STI'],
        },
        "TK-Soft": {
          label: 'TK-Soft',
          itemnum: '3.3.13',
          indications: ['T2V', 'T2M', 'ST', 'STM', 'STV'],
        },
        Stegüberwurf: {
          label: 'Stegüberwurf mit Halteelementen',
          itemnum: '3.3.14',
          indications: ['STE']
        },
        "Steg auf Klebebasen": {
          label: 'Steg auf Klebebasen',
          indications: ['I', 'EO', 'O'],
          children: {
            x2: {
              label: '2 Implantate',
              itemnum: '3.2.15',
            },
            x3: {
              label: '3 Implantate',
              itemnum: '3.2.16',
            },
            x4: {
              label: '4 Implantate',
              itemnum: '3.2.17',
            },
            x5: {
              label: '5 Implantate',
              itemnum: '3.2.18',
            },
            x6: {
              label: '6 Implantate',
              itemnum: '3.2.19',
            },
            x7: {
              label: '7 Implantate',
              itemnum: '3.2.20',
            },
            x8: {
              label: '8 Implantate',
              itemnum: '3.2.21',
            },
          }
        },
        Retainer: {
          label: 'Retainer',
          itemnum: '3.2.22',
          indications: ['RET'],
        },
      }
    },
    ks_3d: {
      label: '3D-Druck',
      children: {
        Löffel: {
          label: 'Löffel',
          itemnum: '3.5.5',
          indications: ['L']
        },
        Modellguss: {
          label: 'Modellguss',
          itemnum: '3.5.6',
          indications: ['MOG']
        },
        Gerüst: {
          label: 'Gerüst',
          itemnum: '3.5.7',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO']
        },
        Schiene: {
          label: 'Schiene',
          itemnum: '3.5.8',
          indications: ['S']
        },
        /*"Indiv. Artikulator": {
          label: 'Indiv. Artikulator',
          itemnum: '2.5.9',
        },*/
      },
    },
    ks_milled: {
      label: 'Kunststoff gefräst',
      children: {
        "Pmma Schiene": {
          label: 'Pmma Schiene',
          itemnum: '3.4.1',
          indications: ['S']
        },
        "Eldy Modellguss": {
          label: 'Eldy Modellguss',
          itemnum: '3.4.2',
          indications: ['MOG']
        },
        "Pmma Gerüst": {
          label: 'Pmma Gerüst',
          itemnum: '3.4.3',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO']
        },
        "Pmma Geschiebe": {
          label: 'Pmma Geschiebe',
          itemnum: '3.4.4',
          indications: ['O']
        },
        "BioHPP Sky elegance prefab": {
          label: 'BioHPP Sky elegance prefab',
          itemnum: '3.4.5',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'KMH']
        },
        "BioHPP Modellguss": {
          label: 'BioHPP Modellguss',
          itemnum: '3.4.6',
          indications: ['MOG']
        },
      }
    },
    glas: {
      label: 'Glaskeramik',
      children: {
        emax_MO: {
          label: 'IPS e.max CAD',
          itemnum: '3.6.1',
          indications: ['K', 'KV', 'KM', 'V', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH'],
        },
        amber: {
          label: 'Amber® Mill CAD/CAM',
          itemnum: '3.6.2',
          indications: ['K', 'KV', 'KM', 'V', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH'],
          properties: {
            color: colors(['A1', 'A2', 'A3', 'A3,5', 'A4', 'B1', 'B2', 'B3', 'B4', 'C1', 'C2', 'C3', 'C4', 'D2', 'D3', 'D4', 'W1', 'W2', 'W3', 'W4']),
          }
        },
      }
    },
    ti: {
      label: 'Titan',
      children: {
        Gerüst: {
          label: 'Gerüst',
          itemnum: '3.7.1',
          maxunits: 50,
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO']
        },
        Primärteleskop: {
          label: 'Primärteleskop',
          itemnum: '3.7.2',
          maxunits: 50,
          indications: ['T1', 'TV', 'TM']
        },
        Modellguss: {
          label: 'Modellguss',
          itemnum: '3.7.3',
          maxunits: 50,
          indications: ['MOG']
        },
        "Multiunit all on": {
          label: 'Multiunit all on …',
          indications: ['I', 'EO', 'O'],
          children: (() => {
            let obj = {};
            for (let c = 4; c < 10; c++)
              obj['x' + (c - 2)] = {
                label: 'Multiunit all on ' + (c - 2),
                itemnum: '3.7.' + c,
              };
              return obj;
          })(),
        },
        Abutment: {
          label: 'Abutment',
          itemnum: '3.7.11',
          maxunits: 50,
          indications: ['I'],
        },
      }
    },
    wax: {
      label: 'Wachs',
      children: {
        Gerüst: {
          label: 'Gerüst',
          itemnum: '3.8.1',
          indications: ['K', 'KV', 'KM', 'PK', 'B', 'BV', 'BM', 'KH', 'KVH', 'O', 'KO', 'KVO', 'KMH', 'KMO', 'V', 'T1']
        },
      }
    }
  }
}
